import { createRouter, createWebHistory } from 'vue-router';
import { storage } from '@/utils/storage';
import { useUserStore, usePopupStore } from '@/store'
import { useHelpTool } from '@/hooks'

const { showLoginDialog, showKycSuspendDialog } = useHelpTool()

const routes = [
  {
    name: 'notFound',
    path: '/:pathMatch(.*)*',
    redirect: {
      name: 'game',
    },
  },
  {
    name: 'login',
    path: '/login',
    component: () => import('./view/user/login'),
  },
  {
    name: 'register',
    path: '/register',
    component: () => import('./view/user/register'),
  },
  {
    name: 'forgetPassword',
    path: '/forgetPassword',
    component: () => import('./view/user/forgetPassword'),
  },
  {
    name: 'tab',
    path: '/tab',
    component: () => import('./layout/TabbarLayout'),
    children:[{
      name: 'game',
      path: '/game',
      component: () => import('./view/game/index'),
    },
    {
      name: 'friendCard',
      path: '/friendCard',
      component: () => import('./view/vip/friendCard'),
    },
    {
      name: 'vip',
      path: '/vip',
      component: () => import('./view/vip/index'),
    },
    {
      name: 'profile',
      path: '/profile',
      component: () => import('./view/user/profile'),
    },
    {
      name: 'event',
      path: '/event',
      component: () => import('./view/rewards/index'),
    }]
  },
  {
    name: 'pokerCollection',
    path: '/pokerCollection',
    component: () => import('./view/vip/poker'),
  },
  {
    name: 'inbox',
    path: '/inbox',
    component: () => import('./view/inbox/index'),
  },
  // {
  //   name: 'inviteRank',
  //   path: '/inviteRank',
  //   component: () => import('./view/vip/rank'),
  // },
  {
    name: 'livechat',
    path: '/livechat',
    component: () => import('./view/livechat/index'),
  },
  // {
  //   name: 'customerService',
  //   path: '/customerService',
  //   component: () => import('./view/livechat/index'),
  // },
  {
    name: 'faq',
    path: '/faq',
    component: () => import('./view/livechat/faq'),
  },
  {
    name: 'gameSearch',
    path: '/game/search',
    component: () => import('./view/game/search'),
  },
  {
    name: 'gameRecord',
    path: '/game/record',
    component: () => import('./view/game/record'),
  },
  {
    name: 'personInfo',
    path: '/personInfo',
    component: () => import('./view/user/personInfo'),
  },
  {
    name: 'kycVerification',
    path: '/kyc/verification',
    component: () => import('./view/user/kyc/verification'),
  },
  {
    name: 'kycBaseInfo',
    path: '/kyc/baseInfo',
    component: () => import('./view/user/kyc/baseInfo'),
  },
  {
    name: 'kycStatus',
    path: '/kyc/status',
    component: () => import('./view/user/kyc/status'),
  },
  {
    name: 'kycUpload',
    path: '/kyc/upload',
    component: () => import('./view/user/kyc/upload'),
  },
  {
    name: 'withdraw',
    path: '/finance/withdraw',
    component: () => import('./view/finance/withdraw'),
  },
  {
    name: 'recharge',
    path: '/finance/recharge',
    component: () => import('./view/finance/deposit'),
  },
  {
    name: 'exchange',
    path: '/finance/exchange',
    component: () => import('./view/finance/exchange'),
  },
  {
    name: 'transactionHistory',
    path: '/transactionHistory',
    component: () => import('./view/finance/record'),
  },
  {
    name: 'records',
    path: '/records',
    component: () => import('./view/records/index'),
  },
  {
    name: 'redeem',
    path: '/redeem',
    component: () => import('./view/redeem/index'),
  },
  {
    name: 'activity',
    path: '/activity/:type/:sn',
    component: () => import('./view/activity/index'),
  },
  {
    name: 'stepTask',
    path: '/stepTask/:sn',
    component: () => import('./view/activity/stepTask'),
  },
  {
    name: 'redEnvelope',
    path: '/envelope/:sn',
    component: () => import('./view/activity/envelope/index'),
  },
  {
    name: 'goldenEgg',
    path: '/egg/:sn',
    component: () => import('./view/activity/egg/index'),
  },
  {
    name: 'spinWheel',
    path: '/spinWheel/:sn',
    component: () => import('./view/activity/spinWheel/index'),
  },
  {
    name: 'giftCenter',
    path: '/giftCenter',
    component: () => import('./view/inbox/giftCenter'),
  }
];

const router = createRouter({
  routes,
  history: createWebHistory(),
});

router.beforeEach((to, from, next) => {
  const title = to.meta && to.meta.title;
  if (title) {
    document.title = title;
  }
  if (!storage.get('userInfo')
    && to.name !== 'login' 
    && to.name !== 'register' 
    && to.name !== 'forgetPassword'
    && to.name !== 'game'
    && to.name !== 'gameSearch'
    && to.name !== 'livechat'
    && to.name !== 'faq'
  ) {
    next({ name: 'game' });
    showLoginDialog();
    return;
  }
  if (useUserStore().onlyKyc
      && to.name !== 'login'
      && to.name !== 'register' 
      && to.name !== 'forgetPassword'
      && to.name !== 'kycVerification'
      && to.name !== 'kycBaseInfo'
      && to.name !== 'kycStatus'
      && to.name !== 'kycUpload'
      && to.name !== 'profile'
      && to.name !== 'personInfo'
      && to.name !== 'livechat'
      && to.name !== 'faq'
  ) {
    showKycSuspendDialog();
    return;
  }
  // 进入充值页面前 未设置kyc跳转到kyc
  if (to.name === 'recharge' && useUserStore().needKycBeforeDeposit) {
    next({ name: 'kycVerification' });
    return;
  }
  // 进入提现页面前 未设置kyc跳转到kyc
  if (to.name === 'withdraw' && useUserStore().needKycBeforeWithdraw) {
    next({ name: 'kycVerification' });
    return;
  }
  // 进入提现页面前 未设置提现密码跳转到安全中心
  if (to.name === 'withdraw' && useUserStore().isNullPasswordTrade) {
    usePopupStore().set('showTransactionPassword');
    return;
  }
  next();
});

export { router };
